/**
 * Convierte una fecha del formato yyyy-mm-dd a dd-mm-yyyy
 * @param {string} fechaStr - Fecha en formato yyyy-mm-dd
 * @returns {string} Fecha en formato dd-mm-yyyy
 */
export const formatearFecha = (fechaStr) => {
  if (!fechaStr || typeof fechaStr !== 'string') return '';
  
  // Verificar si la fecha ya está en formato dd-mm-yyyy
  if (/^\d{2}-\d{2}-\d{4}$/.test(fechaStr)) {
    return fechaStr;
  }
  
  // Convertir de yyyy-mm-dd a dd-mm-yyyy
  const [anio, mes, dia] = fechaStr.split('-');
  if (!anio || !mes || !dia) return fechaStr;
  
  return `${dia}-${mes}-${anio}`;
};

/**
 * Convierte una fecha del formato dd-mm-yyyy a yyyy-mm-dd
 * @param {string} fechaStr - Fecha en formato dd-mm-yyyy
 * @returns {string} Fecha en formato yyyy-mm-dd
 */
export const normalizarFecha = (fechaStr) => {
  if (!fechaStr || typeof fechaStr !== 'string') return '';
  
  // Verificar si la fecha ya está en formato yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}$/.test(fechaStr)) {
    return fechaStr;
  }
  
  // Convertir de dd-mm-yyyy a yyyy-mm-dd
  const [dia, mes, anio] = fechaStr.split('-');
  if (!anio || !mes || !dia) return fechaStr;
  
  return `${anio}-${mes}-${dia}`;
};

// Función para formatear precios con separadores de miles y moneda CLP
export const formatearPrecio = (precio) => {
  return `CLP ${new Intl.NumberFormat('es-CL').format(precio)}`;
}; 